<template>
  <div class="elevation-1">
    <v-form>
      <v-container>
        <v-row>
          <v-col cols="12" sm="10">
            <v-text-field v-model="newRoleName" label="New Role Name" clearable></v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="2">
            <v-btn class="mt-4" color="blue darken-1" v-on:click="addNewRole">Add</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-list v-if="showRoleList">
      <v-list-item-group v-model="item">
        <v-list-item v-for="(item, i) in rolesList" :key="i">
          <v-list-item-content>
            <v-list-item-title
              v-text="item.ID + ': ' + item.name"
            ></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-snackbar v-model="addRoleSuccess" :timeout="snackbarTimeout">
      Successfully Added Role
    </v-snackbar>
    <v-snackbar v-model="addRoleFailure" :timeout="snackbarTimeout">
      Failed to add Role
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      item: 1,
      newRoleName: "",
      showRoleList: false,
      addRoleSuccess: false,
      addRoleFailure: false,
      snackbarTimeout: 1000,
      rolesList: []
    };
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.rolesList = [];
      // fetch user roles for edited user
      axios({
        url: "/api/admin/roles",
        method: "GET"
      })
        .then(response => {
          // if failed to save - make a snackbar show up
          Object.assign(this.rolesList, response.data);
          this.showRoleList = true;
        })
        .catch(() => {
          this.showErrorMessage = true;
        });
    },
    addNewRole() {
      let param = {
        name: this.newRoleName
      };
      axios({
        url: "/api/admin/roles",
        data: param,
        method: "POST"
      })
        .then(res => {
          // if failed to save - make a snackbar show up
          this.rolesList.push(res.data);
          this.addRoleSuccess = true;
        })
        .catch(() => {
          this.addRoleFailure = true;
        });
    }
  }
};
</script>

<style></style>
